/* eslint-disable sonarjs/cognitive-complexity */
import { comparisonTypes } from '../../pages/BuilderPage/Condition/Actions/actionConstants';
import { parseNumberType } from 'src/lib/util/helpers';

const isNumericLike = value => value !== '' && value !== null && value !== undefined && !Number.isNaN(parseNumberType(value));

const normalizeComparableValue = value => (isNumericLike(value) ? parseNumberType(value) : value);

const compareValues = (leftValue, rightValue, comparisonOperator) => {
  const normalizedLeftValue = normalizeComparableValue(leftValue);
  const normalizedRightValue = normalizeComparableValue(rightValue);

  if (comparisonOperator === comparisonTypes.equals) {
    return normalizedLeftValue === normalizedRightValue;
  }

  if (comparisonOperator === comparisonTypes.notEquals) {
    return normalizedLeftValue !== normalizedRightValue;
  }

  if (!isNumericLike(leftValue) || !isNumericLike(rightValue)) {
    return false;
  }

  const digitalLeftValue = parseNumberType(leftValue);
  const digitalRightValue = parseNumberType(rightValue);

  if (comparisonOperator === comparisonTypes.greater) {
    return digitalLeftValue > digitalRightValue;
  }
  if (comparisonOperator === comparisonTypes.greaterOrEqual) {
    return digitalLeftValue >= digitalRightValue;
  }
  if (comparisonOperator === comparisonTypes.less) {
    return digitalLeftValue < digitalRightValue;
  }
  if (comparisonOperator === comparisonTypes.lessOrEqual) {
    return digitalLeftValue <= digitalRightValue;
  }

  return normalizedRightValue;
};

export const logicalComparisons = (accumulator, propertyResult) => {
  if (accumulator.logicalOperator === 'AND') {
    return { value: accumulator.value && propertyResult, logicalOperator: null };
  }
  if (accumulator.logicalOperator === 'OR') {
    return { value: accumulator.value || propertyResult, logicalOperator: null };
  }
  return { ...accumulator, value: propertyResult };
};

export const getArrayComparisons = (accumulator, propertyResult) => {
  if (accumulator.logicalOperator) {
    return logicalComparisons(accumulator, propertyResult);
  }

  if (accumulator.comparisonOperator === comparisonTypes.equals) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem === item))
        : propertyResult.every(item => parseNumberType(accumulator.value) === item),
      comparisonOperator: null,
    };
  }
  if (accumulator.comparisonOperator === comparisonTypes.notEquals) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem !== item))
        : propertyResult.every(item => parseNumberType(accumulator.value) !== item),
      comparisonOperator: null,
    };
  }
  if (accumulator.comparisonOperator === comparisonTypes.greater) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem > item))
        : propertyResult.every(item => parseNumberType(accumulator.value) > item),
      comparisonOperator: null,
    };
  }
  if (accumulator.comparisonOperator === comparisonTypes.greaterOrEqual) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem >= item))
        : propertyResult.every(item => parseNumberType(accumulator.value) >= item),
      comparisonOperator: null,
    };
  }
  if (accumulator.comparisonOperator === comparisonTypes.less) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem < item))
        : propertyResult.every(item => parseNumberType(accumulator.value) < item),
      comparisonOperator: null,
    };
  }
  if (accumulator.comparisonOperator === comparisonTypes.lessOrEqual) {
    return {
      value: Array.isArray(accumulator.value)
        ? propertyResult.every(item => accumulator.value.every(acItem => acItem <= item))
        : propertyResult.every(item => parseNumberType(accumulator.value) <= item),
      comparisonOperator: null,
    };
  }

  return { ...accumulator, value: propertyResult };
};

export const getDigitalComparisons = (accumulator, digitalValue) => {
  if (accumulator.comparisonOperator) {
    const comparisonResult = Array.isArray(accumulator.value)
      ? accumulator.value.every(item => compareValues(item, digitalValue, accumulator.comparisonOperator))
      : compareValues(accumulator.value, digitalValue, accumulator.comparisonOperator);

    if (accumulator.logicalOperator) {
      return logicalComparisons({ value: accumulator.logicalResult, logicalOperator: accumulator.logicalOperator }, comparisonResult);
    }

    return { value: comparisonResult, comparisonOperator: null };
  }

  if (accumulator.logicalOperator) {
    return { ...accumulator, value: digitalValue, logicalResult: accumulator.value };
  }

  return { ...accumulator, value: digitalValue };
};
